/*
 * Duyuru (Announcement) yüzeyi.
 *
 * ÜST BARDA ARTIK AYRI BİR ÇAN YOKTUR. Önceden burada bir `AnnouncementBell` bileşeni vardı ve
 * #806 ile eklenen bildirim çanının yanında ikinci bir çan olarak duruyordu — kullanıcı için iki
 * özdeş ikon, hangisinin ne olduğu belirsiz. İkisi TEK çanda birleştirildi (`ui/NotificationBell`):
 * duyurular o panelin bir bölümü olarak listelenir.
 *
 * Bu dosya duyuru VERİSİNİ ve GÖRÜNTÜLEYİCİSİNİ sağlar; çanı değil. Böylece duyuru mantığı
 * (uç, polling aralığı, sayfalama) bildirim bileşeninin içine kopyalanmaz.
 */
import { useCallback, useEffect, useState } from 'react';

function authHeaders() {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
}

function formatDate(value) {
  if (!value) return '-';
  return new Date(value).toLocaleDateString('tr-TR');
}

/**
 * Aktif duyurular + elle tazeleme. Aralık 5 dakikadır: duyuru, bildirimin aksine anlık bir
 * olay değil süreli bir ilandır — daha sık sormanın karşılığı yok.
 */
export function useActiveAnnouncements() {
  const [items, setItems] = useState([]);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setItems([]);
      return;
    }

    try {
      const res = await fetch('/api/announcements/Active', { headers: authHeaders() });
      if (!res.ok) throw new Error('Duyurular alinamadi');
      const data = await res.json();
      setItems(Array.isArray(data) ? data : []);
    } catch {
      setItems([]);
    }
  }, []);

  useEffect(() => {
    refresh();
    const timer = window.setInterval(refresh, 300000);
    window.addEventListener('auth:logout', refresh);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener('auth:logout', refresh);
    };
  }, [refresh]);

  return { announcements: items, refreshAnnouncements: refresh };
}

/** Tam ekran duyuru okuyucu (önceki/sonraki ile gezinir). */
export function AnnouncementViewer({ items, index, onIndexChange, onClose }) {
  const safeIndex = Math.min(Math.max(index, 0), Math.max(items.length - 1, 0));
  const current = items[safeIndex];
  if (!current) return null;

  return (
    <div className="announcement-viewer-overlay" onClick={onClose}>
      <div className="announcement-viewer" onClick={event => event.stopPropagation()}>
        <div className="announcement-viewer-header">
          <div>
            <p className="announcement-viewer-kicker">Duyuru {safeIndex + 1} / {items.length}</p>
            <h3>{current.title}</h3>
          </div>
          <button type="button" className="announcement-viewer-close" onClick={onClose}>x</button>
        </div>

        {current.imageUrl && (
          <img className="announcement-viewer-image" src={current.imageUrl} alt={current.title} />
        )}

        <div className="announcement-viewer-body">
          <p className="announcement-viewer-date">
            Gecerlilik: {formatDate(current.effectiveStartDate)} - {formatDate(current.effectiveEndDate)}
          </p>
          <p>{current.description || 'Aciklama girilmemis.'}</p>
        </div>

        <div className="announcement-viewer-footer">
          <button
            type="button"
            disabled={safeIndex === 0}
            onClick={() => onIndexChange(Math.max(safeIndex - 1, 0))}
          >
            Onceki
          </button>
          <button
            type="button"
            disabled={safeIndex >= items.length - 1}
            onClick={() => onIndexChange(Math.min(safeIndex + 1, items.length - 1))}
          >
            Sonraki
          </button>
        </div>
      </div>
    </div>
  );
}
